import { cfApiClient } from '@/api/cf-worker-client';
import { authService } from '@/auth';

export const aiService = {
    generateText: async (name: string, category: string): Promise<string> => {
        const response = await cfApiClient.post<{ success: boolean; data: { text: string }; error?: string }>('/ai/generate-text', {
            name,
            category,
        }, { timeout: 60000 });

        if (response.success && response.data) {
            return response.data.text;
        }
        throw new Error(response.error || 'Failed to generate text');
    },

    generateImage: async (prompt: string): Promise<Blob> => {
        // Since BaseApiClient.post assumes JSON response, we override for blobs
        const token = authService.getAccessToken();
        const baseUrl = (cfApiClient as any).baseUrl;

        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 60000);

        try {
            const response = await fetch(`${baseUrl}/ai/generate-image`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token ? `Bearer ${token}` : '',
                },
                body: JSON.stringify({ prompt }),
                signal: controller.signal,
            });

            clearTimeout(timeoutId);
            if (!response.ok) throw new Error('Failed to generate image');
            return await response.blob();
        } catch (error) {
            clearTimeout(timeoutId);
            throw error;
        }
    },
};
